/* eslint-disable import/prefer-default-export */
export var validFileSize = function validFileSize(number) {
  return number < 8388608;
};
export var validFileType = function validFileType(type) {
  return ['image/jpeg', 'image/pjpeg', 'image/png'].indexOf(type) > -1;
};